<div class="container-fluid">
  <div class="row">
    <div class="col-md-6 col-xl-7 p-2" style="background-color: #f1f1f1;">
      <div class="descricao">
        <div class="formulario-duvidas">
          <p class="pt-5">
            <span>Atendimento</span>
          </p>
          <p class="title-form-pages pb-4">Dúvidas Frequentes</p>

          <div *ngFor="let perguntasFrequentes of duvidasFrequentes; let i = index" [ngClass]="{
              'ultimo-elemento': i === duvidasFrequentes!.length - 1
            }">
            <p class="blue">
              {{ perguntasFrequentes.pergunta }}
            </p>
            <p class="gray response-style-link" [innerHTML]="perguntasFrequentes.resposta"></p>
          </div>
        </div>

        <p class="texto-duvidas p-1 p-md-2 p-lg-4 pt-5">
          Tem alguma dúvida que não foi respondida nas questões acima? Utilize o
          formulário ao lado para nos enviar sua questão e muito em breve
          entraremos em contato com você!
        </p>
      </div>
    </div>

    <div class="col-md-6 col-xl-5 p-2 p-md-4">
      <div class="p-2 p-md-4">

        <p class="title-pages-pergunta pt-5 pb-2 pb-md-4">
          <span>Faça uma pergunta</span>
        </p>
        <form [formGroup]="perguntasFrequentes" (submit)="onSubmit('Perguntas Frequentes')">
          <div class="form-group">
            <input class="form-control global-input-style" formControlName="nome" type="text" name="nome"
              (change)="saverange($event, 'nome')" placeholder="Nome" [class.error]="
              perguntasFrequentes.controls['nome'].errors &&
              (perguntasFrequentes.controls['nome'].dirty ||
                perguntasFrequentes.controls['nome'].touched ||
                submitted)
            " />

            <span class="text-danger"
              *ngIf="perguntasFrequentes.controls['nome'].errors?.['required'] && (perguntasFrequentes.controls['nome'].dirty || (perguntasFrequentes.controls['nome'].touched) || submitted)">
              Nome é necessário.
            </span>
            <span class="text-danger"
              *ngIf="!perguntasFrequentes.controls['nome'].errors?.['required'] && (perguntasFrequentes.controls['nome'].dirty || (perguntasFrequentes.controls['nome'].touched) || submitted) && perguntasFrequentes.controls['nome'].errors">
              Nome inválido.
            </span>
          </div>

          <div class="form-group">
            <input class="form-control global-input-style" formControlName="email" type="text" placeholder="E-mail"
              (change)="saverange($event, 'email')" [class.error]="
              perguntasFrequentes.controls['email'].errors &&
              (perguntasFrequentes.controls['email'].dirty ||
                perguntasFrequentes.controls['email'].touched ||
                submitted)
            " />

            <span class="text-danger"
              *ngIf="perguntasFrequentes.controls['email'].errors?.['required'] && (perguntasFrequentes.controls['email'].dirty || (perguntasFrequentes.controls['email'].touched)|| submitted)">
              E-mail é necessário.
            </span>
            <span class="text-danger"
              *ngIf="!perguntasFrequentes.controls['email'].errors?.['required'] && (perguntasFrequentes.controls['email'].dirty || (perguntasFrequentes.controls['email'].touched)|| submitted) && perguntasFrequentes.controls['email'].errors">
              E-mail inválido.
            </span>
          </div>

          <div class="form-group">
            <input class="form-control global-input-style" formControlName="telefone" type="text"
              mask="(00)0000-0000 || (00)00000-0000 " placeholder="Telefone" [class.error]="
              perguntasFrequentes.controls['telefone'].errors &&
              (perguntasFrequentes.controls['telefone'].dirty ||
                perguntasFrequentes.controls['telefone'].touched ||
                submitted)
            " />
            <span class="text-danger"
              *ngIf="perguntasFrequentes.controls['telefone'].errors?.['required'] && (perguntasFrequentes.controls['telefone'].dirty || (perguntasFrequentes.controls['telefone'].touched)|| submitted)">
              Telefone é necessário.
            </span>
            <span class="text-danger"
              *ngIf="!perguntasFrequentes.controls['telefone'].errors?.['required'] && (perguntasFrequentes.controls['telefone'].dirty || (perguntasFrequentes.controls['telefone'].touched)|| submitted) && perguntasFrequentes.controls['telefone'].errors">
              Telefone inválido.
            </span>
          </div>

          <div class="form-group">
            <select class="form-select" formControlName="estado"
              [class.error]="perguntasFrequentes.controls['estado'].errors?.['required'] && (perguntasFrequentes.controls['estado'].dirty || (perguntasFrequentes.controls['estado'].touched)|| submitted)">
              <option value="" disabled [selected]="!perguntasFrequentes.controls['estado'].value">
                Selecione um estado
              </option>
              <option *ngFor="let estado of listaEstados" [value]="estado.nome">
                {{ estado.nome }}
              </option>
            </select>
            <span class="text-danger"
              *ngIf="perguntasFrequentes.controls['estado'].errors?.['required'] && (perguntasFrequentes.controls['estado'].dirty || (perguntasFrequentes.controls['estado'].touched)|| submitted)">
              Selecione um estado.
            </span>
          </div>

          <div class="form-group">
            <select class="form-select" formControlName="cidade"
              [class.error]="perguntasFrequentes.controls['cidade'].errors?.['required'] && (perguntasFrequentes.controls['cidade'].dirty || (perguntasFrequentes.controls['cidade'].touched)|| submitted)">
              <option value="" *ngIf="perguntasFrequentes.controls['estado'].errors">
                Selecione um estado primeiro
              </option>
              <option value="" [selected]="!perguntasFrequentes.controls['cidade'].value"
                *ngIf="!perguntasFrequentes.controls['estado'].errors">
                Selecione uma cidade
              </option>
              <option *ngFor="let cidade of listaCidades[0]" [value]="cidade">
                {{ cidade }}
              </option>
            </select>
            <span class="text-danger"
              *ngIf="perguntasFrequentes.controls['cidade'].errors?.['required'] && (perguntasFrequentes.controls['cidade'].dirty || (perguntasFrequentes.controls['cidade'].touched)|| submitted)">
              Selecione a cidade.
            </span>
          </div>

          <div class="form-group">
            <input class="form-control global-input-style" type="text" formControlName="endereco"
              (change)="saverange($event, 'endereco')" placeholder="Endereço" [class.error]="
              perguntasFrequentes.controls['endereco'].errors &&
              (perguntasFrequentes.controls['endereco'].dirty ||
                perguntasFrequentes.controls['endereco'].touched ||
                submitted)
            " />

            <span class="text-danger"
              *ngIf="perguntasFrequentes.controls['endereco'].errors?.['required'] && (perguntasFrequentes.controls['endereco'].dirty || (perguntasFrequentes.controls['endereco'].touched)|| submitted)">
              Endereço é necessário.
            </span>
            <span class="text-danger"
              *ngIf="!perguntasFrequentes.controls['endereco'].errors?.['required'] && (perguntasFrequentes.controls['endereco'].dirty || (perguntasFrequentes.controls['endereco'].touched)|| submitted) && perguntasFrequentes.controls['endereco'].errors">
              Endereço inválido.
            </span>
          </div>

          <div class="form-group">
            <input class="form-control global-input-style" formControlName="bairro" type="text" placeholder="Bairro"
              (change)="saverange($event, 'bairro')" [class.error]="
              perguntasFrequentes.controls['bairro'].errors &&
              (perguntasFrequentes.controls['bairro'].dirty ||
                perguntasFrequentes.controls['bairro'].touched ||
                submitted)
            " />

            <span class="text-danger"
              *ngIf="perguntasFrequentes.controls['bairro'].errors?.['required'] && (perguntasFrequentes.controls['bairro'].dirty || (perguntasFrequentes.controls['bairro'].touched)|| submitted)">
              Bairro é necessário.
            </span>
            <span class="text-danger"
              *ngIf="!perguntasFrequentes.controls['bairro'].errors?.['required'] && (perguntasFrequentes.controls['bairro'].dirty || (perguntasFrequentes.controls['bairro'].touched)|| submitted) && perguntasFrequentes.controls['bairro'].errors">
              Bairro inválido.
            </span>
          </div>

          <div class="form-group">
            <input class="form-control global-input-style" formControlName="cep" type="text" mask="00000-000"
              placeholder="CEP" [class.error]="
              perguntasFrequentes.controls['cep'].errors &&
              (perguntasFrequentes.controls['cep'].dirty ||
                perguntasFrequentes.controls['cep'].touched ||
                submitted)
            " />
            <span class="text-danger"
              *ngIf="perguntasFrequentes.controls['cep'].errors?.['required'] && (perguntasFrequentes.controls['cep'].dirty || (perguntasFrequentes.controls['cep'].touched)|| submitted)">
              CEP é necessário.
            </span>
            <span class="text-danger"
              *ngIf="!perguntasFrequentes.controls['cep'].errors?.['required'] && (perguntasFrequentes.controls['cep'].dirty || (perguntasFrequentes.controls['cep'].touched)|| submitted) && perguntasFrequentes.controls['cep'].errors">
              CEP inválido.
            </span>
          </div>

          <textarea class="form-control" id="mensagem"  formControlName="mensagem" style="height: auto !important; resize: none"
            rows="6" placeholder="Mensagem" (input)="contarCaracteres($event)" (change)="saverange($event, 'mensagem')" [class.error]="
            perguntasFrequentes.controls['mensagem'].errors &&
            (perguntasFrequentes.controls['mensagem'].dirty ||
              perguntasFrequentes.controls['mensagem'].touched ||
              submitted)
          "></textarea>

          <span class="text-danger"
            *ngIf="perguntasFrequentes.controls['mensagem'].errors?.['required'] && (perguntasFrequentes.controls['mensagem'].dirty || (perguntasFrequentes.controls['mensagem'].touched)|| submitted)">
            Mensagem é necessária.
          </span>
          <span class="text-danger"
            *ngIf="!perguntasFrequentes.controls['mensagem'].errors?.['required'] && (perguntasFrequentes.controls['mensagem'].dirty || (perguntasFrequentes.controls['mensagem'].touched)|| submitted) && perguntasFrequentes.controls['mensagem'].errors">
            Mensagem inválido. {{quantidadeCaracteres}} caractere(s) restante(s).
          </span>

          <div class="p-2 p-md-4">
            <button [disabled]="submitted" class="btn-submit-form mb-2 mt-3" type="submit">Enviar</button>

          </div>
        </form>
      </div>

    </div>
  </div>
</div>
